export default __webpack_public_path__ + "static/media/search-icon-dark.f8aa76b5.svg";